<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 10.9342C16.25 10.6404 16.25 10.4935 16.2942 10.3626C16.4228 9.98218 16.7615 9.83455 17.1009 9.67995C17.4825 9.50615 17.6733 9.41925 17.8623 9.40396C18.0769 9.38661 18.2919 9.43284 18.4753 9.53579C18.7185 9.67226 18.8881 9.93159 19.0617 10.1425C19.8636 11.1164 20.2646 11.6034 20.4113 12.1405C20.5297 12.5739 20.5297 13.0271 20.4113 13.4604C20.1973 14.2437 19.5213 14.9003 19.0209 15.5081C18.7649 15.819 18.6369 15.9744 18.4753 16.0651C18.2919 16.1681 18.0769 16.2143 17.8623 16.197C17.6733 16.1817 17.4825 16.0948 17.1009 15.921C16.7615 15.7664 16.4228 15.6187 16.2942 15.2383C16.25 15.1074 16.25 14.9605 16.25 14.6667V10.9342Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M7.75 10.9343C7.75 10.5644 7.73961 10.2319 7.44052 9.97177C7.33173 9.87716 7.1875 9.81147 6.89905 9.68009C6.51748 9.50629 6.3267 9.41939 6.13766 9.4041C5.57048 9.35823 5.26533 9.74533 4.93825 10.1426C4.13637 11.1166 3.73542 11.6036 3.58871 12.1406C3.47032 12.574 3.47032 13.0272 3.58871 13.4606C3.8027 14.2439 4.47873 14.9004 4.97913 15.5082C5.29455 15.8913 5.59586 16.2409 6.13766 16.1971C6.3267 16.1818 6.51748 16.0949 6.89905 15.9211C7.1875 15.7897 7.33173 15.724 7.44052 15.6294C7.73961 15.3693 7.75 15.0368 7.75 14.6668V10.9343Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M6.05078 9.3999C6.05078 6.5832 8.71474 4.2998 12.0009 4.2998C15.2871 4.2998 17.951 6.5832 17.951 9.3999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M17.9487 16.2002V16.8802C17.9487 18.3825 16.4265 19.6003 14.5487 19.6003H12.8486"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
